export const officeSkillsData = [
  { 
    name: "BulMar Office", 
    description: "Счетоводство+, ТРЗ - счетоводен софтуер за обработка на счетоводни документи, ведомости за заплати и финансови отчети.", 
    icon: "fa-calculator", 
    link: "https://bulmar.com/bg/accounting-software" 
  },
  { 
    name: "Кредо 2000", 
    description: "ERP система за счетоводство и управление - интегрирано решение за счетоводна отчетност, складово стопанство и търговска дейност.", 
    icon: "fa-database", 
    link: "#" 
  },
  { 
    name: "MS Office", 
    description: "Excel, Word, Outlook, PowerPoint - професионален софтуерен пакет за работа с документи, таблици, презентации и електронна поща.", 
    icon: "fa-file-excel", 
    link: "#" 
  },
  { 
    name: "Google Workspace", 
    description: "Gmail, Drive, Docs, Sheets, Calendar, Meet - облачни инструменти за съхранение, обработка и споделяне на документи и комуникация.", 
    icon: "fa-cloud", 
    link: "#" 
  },
  { 
    name: "Google Analytics", 
    description: "Анализ на уеб трафик, проследяване на посетители, поведенчески анализи, GA4 конфигурация и отчитане на резултати.", 
    icon: "fa-chart-line", 
    link: "#" 
  },
  { 
    name: "CRM Системи", 
    description: "Управление на клиентски взаимоотношения, проследяване на продажби, автоматизация на маркетинга и анализ на клиентски данни.", 
    icon: "fa-handshake", 
    link: "#" 
  }
];